import React from "react";
import {} from "./MessagesList.css";
// Libraries
import { PropTypes } from "prop-types";
// Components
import MessagesListItem from "./MessagesListItem";
// Consts
import { userTypes } from "../../../CommonConstants";
const { admin, manager, driver } = userTypes;

const MessagesList = (props) => {
  const { data } = props;
  return (
    <div>
      {data.map((item, index) => (
        <MessagesListItem
          {...item}
          key={`MessagesListItem-${index}`}
          isOwnMessage={admin.type === item.senderType}
        />
      ))}
    </div>
  );
};

MessagesList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      senderType: PropTypes.oneOf([admin.type, manager.type, driver.type]),
      senderName: PropTypes.string.isRequired,
    }).isRequired
  ),
};

export default MessagesList;



// WEBPACK FOOTER //
// ./src/Components/Lists/MessagesList/MessagesList.js